import { render, staticRenderFns } from "./TmFormMsg.vue?vue&type=template&id=2fdfc4d8&"
import script from "./TmFormMsg.vue?vue&type=script&lang=js&"
export * from "./TmFormMsg.vue?vue&type=script&lang=js&"
import style0 from "./TmFormMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports